import React, { useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"

import Button from '@material-ui/core/Button';
import './OutputSwitch.scss'

function OutputSwitch ({getView}){

    const [view, setView] = useState(0)
    const selectView = (id) => {
        setView(id)
        getView(id)
    };  

    return(
        <div className="OutputSwitch">
            <div className="Switch">
                <Button variant="contained" className={view === 0 ? "SwitchButton active" : "SwitchButton"} onClick={() => selectView(0)}>
                    View by Table
                </Button>
                <Button variant="contained" className={view === 1 ? "SwitchButton active" : "SwitchButton"} onClick={() => selectView(1)}>
                    View by Region
                </Button>
            </div>
        </div>
    )
}

export default OutputSwitch